var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-panel"},[(_vm.isStudent)?_c('RollCall'):_c('RollCallTeacher'),_c('AnswerMachine'),_c('Quiz'),_c('MediaPlayer'),_c('Lottery'),_c('AttentionDetection'),_c('SettingDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }